import script from "./CustomerHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerHome.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__